import React from "react";
import Header from "./Reusables/Header";
import REPHQLevelTable from "./Tables/REPHQLevelTable";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadImg from "../assests/download.svg";
import PeriodSelector from "./PeriodSelector";

const REPHQBudget = () => {




  return (
    <div className="bg-white home-screen">
     
     <PeriodSelector/>
      <REPHQLevelTable style={{ marginTop: "20px", marginRight: "10px" }} />
    
    </div>
  );
};

export default REPHQBudget;
